module.exports = __webpack_public_path__ + "static/media/events_04.1c77a805.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_04.jpg
// module id = 5922
// module chunks = 0